import { useQueryClient } from "@tanstack/react-query";
import PeopleEditor, { type PersonRow } from "@/components/PeopleEditor";
import { saveCustomerSalesReps, useAuthToken, useCustomerSalesReps } from "@/lib/hooks";

export default function SalesRepsEditor({ customerId }: { customerId: string }) {
  const token = useAuthToken();
  const queryClient = useQueryClient();
  const { data, isLoading } = useCustomerSalesReps(customerId);

  const people: PersonRow[] = (data?.sales_reps ?? []).map((r) => ({
    id: r.id,
    name: r.full_name,
    email: r.email,
    phone: r.phone,
    is_current: r.is_current,
  }));

  async function onSave(rows: PersonRow[]) {
    const res = await saveCustomerSalesReps(
      token,
      customerId,
      rows.map((r) => ({
        full_name: r.name,
        email: r.email,
        phone: r.phone,
        is_current: r.is_current ?? true,
      })),
    );
    queryClient.setQueryData(["customer-sales-reps", customerId], res);
  }

  return (
    <PeopleEditor
      heading="Accuryn sales rep"
      people={people}
      isLoading={isLoading}
      onSave={onSave}
      showCurrent
      emptyText="No sales rep on record yet."
      addLabel="Add rep"
      noteText="Names are filled in automatically from invoice data; add phone/email here. Uncheck 'Currently on this account' for former reps."
      exportBase={`${data?.customer_name ?? customerId}-sales-reps`}
    />
  );
}
